const Swiper = require('../../modules/swiper').default

module.exports = {
    loadMap(eventParam = {}, params = {}, autolocation = false) {
        $filter.startLoading()

        if (JSON.stringify(eventParam) !== '{}') {
            $app.runEvent('filter', eventParam)
        }

        $helpers.makePopupMap((Map, fancy) => {
            let data = { ...$filter.getData(), ...(typeof params === 'string' ? Object.fromEntries(new URLSearchParams(params)) : params) }

            this.loadBarsForMap(Map, data).then(({ features }) => {
                features.length ? Map.setAutoLocation(autolocation) : fancy.close()

                $filter.stopLoading()
            })
        })

        return false
    },

    loadBarsForMap(Map, data = {}) {
        return $.get($app.urlPrefix + '/bar/yandex/getMap', data, response => {
            this.setPlacemarks(Map, response)

            if (! response.features.length) {
                swal.fire('Заведений не найдено :(', 'Попробуйте изменить фильтр и заново открыть карту', 'info')
            }
        })
    },

    setPlacemarks(Map, data) {
        Map.map.geoObjects.removeAll()

        if (!data.features.length) {
            Map.map.setCenter($app.cityCoords, 9)

            return false
        }

        let manager = new Map.api.ObjectManager({
            gridSize: 96,
            clusterize: true,
            minClusterSize: 4,
            openEmptyBalloon: true
        })

        manager.objects.events.add('balloonopen', event => {
            let placemark = manager.objects.balloon.getData(),
                setBalloonContent = balloonContent => {
                    manager.objects.balloon.setData({ placemark, properties: { balloonContent } }).then(() => {
                        Swiper('ymaps[class$="-balloon__content"] .swiper', { breakpoints: null, pagination: { type: null } })
                    })
                }

            setBalloonContent('<div class="p-3">Загрузка...</div>')

            $.get($app.urlPrefix + '/bar/yandex/getBalloonContent?id=' + event.get('objectId'), setBalloonContent)
        });

        manager.add(data)

        Map.map.geoObjects.add(manager)

        if (data.features.length === 1) {
            Map.map.setCenter(data.features[0].geometry.coordinates, 15)
        } else {
            Map.map.setBounds(manager.getBounds())
        }

        Map.map.container.fitToViewport()
    },

    nearWithAddress() {
        swal.fire({
            input: 'text',
            showCloseButton: true,
            title: 'Введите адрес',
            inputValidator: value => {
                if (value.length < 3) {
                    return 'Введите минимум 3 буквы'
                }
            }
        }).then(result => {
            if (result.isDismissed) {
                return false
            }

            $helpers.makePopupMap(Map => {
                let searchControl = Map.map.controls.get('searchControl'),
                    fullscreenControl = Map.map.controls.get('fullscreenControl'),
                    showResult = result => {
                        this.loadBarsForMap(Map).then(() => {
                            Map.map.geoObjects.add(
                                Map.makePlacemark(result.geometry.getCoordinates(), 'islands#blueGovernmentIcon')
                            )

                            Map.map.setCenter(result.geometry.getCoordinates(), 15)
                        })
                    }

                searchControl.state.set('size', 'large')
                searchControl.options.set('noPlacemark', true)
                searchControl.options.set('boundedBy', [[54.766461, 36.085498], [56.421014, 39.255053]])

                fullscreenControl.enterFullscreen()

                fullscreenControl.events.add('fullscreenexit', $.fancybox.close())

                searchControl.search(result.value).then(() => {
                    if (searchControl.state.get('found') > 1) {
                        searchControl.events.add('resultselect', event => {
                            searchControl.getResult(event.get('index')).then(showResult)
                        })
                    } else {
                        searchControl.getResult(0).then(showResult)
                    }
                })
            })
        })

        return false
    }
}